import { render, staticRenderFns } from "./menu-menu.vue?vue&type=template&id=692378ba&scoped=true&lang=pug"
import script from "./menu-menu.vue?vue&type=script&lang=coffee"
export * from "./menu-menu.vue?vue&type=script&lang=coffee"
import style0 from "./menu-menu.vue?vue&type=style&index=0&id=692378ba&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "692378ba",
  null
  
)

export default component.exports